/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export enum ProductBriefStatus {
  INITIAL = "initial",
  BENCHMARKING = "benchmarking",
  RAW_MATERIAL_SELECTION = "raw_material_selection",
  PREPARING_STARTER_FORMULA = "preparing_starter_formula",
  COMPLETE = "complete",
  ERROR_BENCHMARKING = "error_benchmarking",
  ERROR_RAW_MATERIAL_SELECTION = "error_raw_material_selection",
  ERROR_PREPARING_STARTER_FORMULA = "error_preparing_starter_formula",
}
